module.exports = __webpack_public_path__ + "static/media/YM26_0.fd1b9c43.jpg";